import ErrorMonitorEnum from '@/domain/error-monitor/error-monitor-enum';

export default class ErrorMonitorTag {
  static getDescription(error: ErrorMonitorEnum): string {
    switch (error) {
      case ErrorMonitorEnum.ERROR:
        return 'Erro';
      case ErrorMonitorEnum.ALERT:
        return 'Alerta';
      default:
        return '';
    }
  }

  static getColor(error: ErrorMonitorEnum): string {
    switch (error) {
      case ErrorMonitorEnum.ERROR:
        return 'red';
      case ErrorMonitorEnum.ALERT:
        return 'yellow';
      default:
        return 'gray';
    }
  }

  static getAllOptions(): Array<{ value: string; text: string }> {
    return [
      {
        value: ErrorMonitorEnum.ERROR,
        text: this.getDescription(ErrorMonitorEnum.ERROR),
      },
      {
        value: ErrorMonitorEnum.ALERT,
        text: this.getDescription(ErrorMonitorEnum.ALERT),
      },
    ];
  }
}
